<template>
  <div class="default-filter-date">
    <v-menu
      ref="menu"
      v-model="menuFilterDate"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="filterDate"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formattedFilterDate"
          :label="label"
          append-icon="event"
          width="160px"
          outline
          readonly
          v-on="on"
          @click:append="menuFilterDate = true"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="filterDate"
        :type="kind"
        :min="minDate"
        no-title
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="cleanFilterDate()">{{i18n('Limpar')}}</v-btn>
        <v-btn flat color="primary" @click="selectFilterDate()">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'DefaultFilterDate',
  props: {
    kind: {
      type: String,
      default: 'month'
    },
    label: {
      type: String,
      default: 'Data'
    },
    minDate: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      filterDate: null,
      menuFilterDate: false,
    }
  },
  watch: {
    'filterDate'(val, old_val) {
      if (val != old_val) {
        this.selectFilterDate()
      }
    }
  },
  computed: {
    formattedFilterDate() {
      if(this.filterDate === null) {
        return null
      }
      const splitted = this.filterDate.split('-')
      const year = Number(splitted[0])
      const month = Number(splitted[1])
      let day = 1
      let day_part = ''
      if (this.kind == 'date') {
        day = Number(splitted[2])
        day_part = String(day).padStart(2, '0') + '/'
      }
      const date = new Date(year, month - 1, day)
      const formattedMonth = date.toLocaleString('default', { month: 'short' });
      return `${day_part}${formattedMonth.toUpperCase()}/${year}`
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    selectFilterDate() {
      this.$refs.menu.save(this.filterDate)
      this.$emit('reload', this.filterDate)
    },
    cleanFilterDate() {
      this.filterDate = null
      this.$refs.menu.save(this.filterDate)
      this.$emit('reload', this.filterDate)
    }
  }
}
</script>

<style>
.default-filter-date .v-text-field .v-text-field__slot input {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/filters/DefaultFilterDate.vue